// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"a8130e42","884":"bde351d2"}[chunkId] + ".chunk.js";
};